/* eslint-disable */
import axios from 'axios'
import qs from 'qs'
let domain = ''
export const getDomain = () => {
  return domain
}
export const setDomain = ($domain) => {
  domain = $domain
}
export const request = (method, url, body, queryParameters, form, config) => {
  method = method.toLowerCase()
  let keys = Object.keys(queryParameters)
  let queryUrl = url
  if (keys.length > 0) {
    queryUrl = url + '?' + qs.stringify(queryParameters)
  }
  // let queryUrl = url+(keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
  if (body) {
    return axios[method](queryUrl, body, config)
  } else if (method === 'get') {
    return axios[method](queryUrl, {
      params: form
    }, config)
  } else {
    return axios[method](queryUrl, qs.stringify(form), config)
  }
}
/*==========================================================
 *                    ivk API documentation
 ==========================================================*/
/**
 * getAccount
 * request: getAccountUsingGET
 * url: getAccountUsingGETURL
 * method: getAccountUsingGET_TYPE
 * raw_url: getAccountUsingGET_RAW_URL
 */
export const getAccountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/account'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAccountUsingGET_RAW_URL = function() {
  return '/account'
}
export const getAccountUsingGET_TYPE = function() {
  return 'get'
}
export const getAccountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/account'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * saveAccount
 * request: saveAccountUsingPOST
 * url: saveAccountUsingPOSTURL
 * method: saveAccountUsingPOST_TYPE
 * raw_url: saveAccountUsingPOST_RAW_URL
 * @param userDto - userDTO
 */
export const saveAccountUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/account'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['userDto'] !== undefined) {
    body = parameters['userDto']
  }
  if (parameters['userDto'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userDto'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const saveAccountUsingPOST_RAW_URL = function() {
  return '/account'
}
export const saveAccountUsingPOST_TYPE = function() {
  return 'post'
}
export const saveAccountUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/account'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * changePassword
 * request: changePasswordUsingPOST
 * url: changePasswordUsingPOSTURL
 * method: changePasswordUsingPOST_TYPE
 * raw_url: changePasswordUsingPOST_RAW_URL
 * @param passwordChangeDto - passwordChangeDto
 */
export const changePasswordUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/account/change-password'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['passwordChangeDto'] !== undefined) {
    body = parameters['passwordChangeDto']
  }
  if (parameters['passwordChangeDto'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: passwordChangeDto'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const changePasswordUsingPOST_RAW_URL = function() {
  return '/account/change-password'
}
export const changePasswordUsingPOST_TYPE = function() {
  return 'post'
}
export const changePasswordUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/account/change-password'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteAccount
 * request: deleteAccountUsingDELETE
 * url: deleteAccountUsingDELETEURL
 * method: deleteAccountUsingDELETE_TYPE
 * raw_url: deleteAccountUsingDELETE_RAW_URL
 */
export const deleteAccountUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/account/delete'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteAccountUsingDELETE_RAW_URL = function() {
  return '/account/delete'
}
export const deleteAccountUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteAccountUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/account/delete'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * finishPasswordReset
 * request: finishPasswordResetUsingPOST
 * url: finishPasswordResetUsingPOSTURL
 * method: finishPasswordResetUsingPOST_TYPE
 * raw_url: finishPasswordResetUsingPOST_RAW_URL
 * @param keyAndPassword - keyAndPassword
 */
export const finishPasswordResetUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/account/reset-password/finish'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['keyAndPassword'] !== undefined) {
    body = parameters['keyAndPassword']
  }
  if (parameters['keyAndPassword'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: keyAndPassword'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const finishPasswordResetUsingPOST_RAW_URL = function() {
  return '/account/reset-password/finish'
}
export const finishPasswordResetUsingPOST_TYPE = function() {
  return 'post'
}
export const finishPasswordResetUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/account/reset-password/finish'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * requestPasswordReset
 * request: requestPasswordResetUsingPOST
 * url: requestPasswordResetUsingPOSTURL
 * method: requestPasswordResetUsingPOST_TYPE
 * raw_url: requestPasswordResetUsingPOST_RAW_URL
 * @param mail - mail
 */
export const requestPasswordResetUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/account/reset-password/init'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['mail'] !== undefined) {
    body = parameters['mail']
  }
  if (parameters['mail'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: mail'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const requestPasswordResetUsingPOST_RAW_URL = function() {
  return '/account/reset-password/init'
}
export const requestPasswordResetUsingPOST_TYPE = function() {
  return 'post'
}
export const requestPasswordResetUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/account/reset-password/init'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * activateAccount
 * request: activateAccountUsingGET
 * url: activateAccountUsingGETURL
 * method: activateAccountUsingGET_TYPE
 * raw_url: activateAccountUsingGET_RAW_URL
 * @param key - key
 */
export const activateAccountUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/activate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['key'] !== undefined) {
    queryParameters['key'] = parameters['key']
  }
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const activateAccountUsingGET_RAW_URL = function() {
  return '/activate'
}
export const activateAccountUsingGET_TYPE = function() {
  return 'get'
}
export const activateAccountUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/activate'
  if (parameters['key'] !== undefined) {
    queryParameters['key'] = parameters['key']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAllByRouteIdArrivalDateArrivalTime
 * request: getAllByRouteIdArrivalDateArrivalTimeUsingGET
 * url: getAllByRouteIdArrivalDateArrivalTimeUsingGETURL
 * method: getAllByRouteIdArrivalDateArrivalTimeUsingGET_TYPE
 * raw_url: getAllByRouteIdArrivalDateArrivalTimeUsingGET_RAW_URL
 * @param arrivalDate - arrivalDate
 * @param arrivalTime - arrivalTime
 * @param page - Page number of the requested page
 * @param routeId - routeId
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getAllByRouteIdArrivalDateArrivalTimeUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/auditlog'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['arrivalDate'] !== undefined) {
    queryParameters['arrivalDate'] = parameters['arrivalDate']
  }
  if (parameters['arrivalDate'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: arrivalDate'))
  }
  if (parameters['arrivalTime'] !== undefined) {
    queryParameters['arrivalTime'] = parameters['arrivalTime']
  }
  if (parameters['arrivalTime'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: arrivalTime'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['routeId'] !== undefined) {
    queryParameters['routeId'] = parameters['routeId']
  }
  if (parameters['routeId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: routeId'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllByRouteIdArrivalDateArrivalTimeUsingGET_RAW_URL = function() {
  return '/auditlog'
}
export const getAllByRouteIdArrivalDateArrivalTimeUsingGET_TYPE = function() {
  return 'get'
}
export const getAllByRouteIdArrivalDateArrivalTimeUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/auditlog'
  if (parameters['arrivalDate'] !== undefined) {
    queryParameters['arrivalDate'] = parameters['arrivalDate']
  }
  if (parameters['arrivalTime'] !== undefined) {
    queryParameters['arrivalTime'] = parameters['arrivalTime']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['routeId'] !== undefined) {
    queryParameters['routeId'] = parameters['routeId']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAllByRouteId
 * request: getAllByRouteIdUsingGET
 * url: getAllByRouteIdUsingGETURL
 * method: getAllByRouteIdUsingGET_TYPE
 * raw_url: getAllByRouteIdUsingGET_RAW_URL
 * @param page - Page number of the requested page
 * @param routeId - routeId
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getAllByRouteIdUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/auditlog/{routeId}'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{routeId}', `${parameters['routeId']}`)
  if (parameters['routeId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: routeId'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllByRouteIdUsingGET_RAW_URL = function() {
  return '/auditlog/{routeId}'
}
export const getAllByRouteIdUsingGET_TYPE = function() {
  return 'get'
}
export const getAllByRouteIdUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/auditlog/{routeId}'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  path = path.replace('{routeId}', `${parameters['routeId']}`)
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * isAuthenticated
 * request: isAuthenticatedUsingGET
 * url: isAuthenticatedUsingGETURL
 * method: isAuthenticatedUsingGET_TYPE
 * raw_url: isAuthenticatedUsingGET_RAW_URL
 */
export const isAuthenticatedUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/authenticate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const isAuthenticatedUsingGET_RAW_URL = function() {
  return '/authenticate'
}
export const isAuthenticatedUsingGET_TYPE = function() {
  return 'get'
}
export const isAuthenticatedUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/authenticate'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * authorize
 * request: authorizeUsingPOST
 * url: authorizeUsingPOSTURL
 * method: authorizeUsingPOST_TYPE
 * raw_url: authorizeUsingPOST_RAW_URL
 * @param loginVm - loginVM
 */
export const authorizeUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/authenticate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['loginVm'] !== undefined) {
    body = parameters['loginVm']
  }
  if (parameters['loginVm'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: loginVm'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const authorizeUsingPOST_RAW_URL = function() {
  return '/authenticate'
}
export const authorizeUsingPOST_TYPE = function() {
  return 'post'
}
export const authorizeUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/authenticate'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAllDemandDrivenRoutes
 * request: getAllDemandDrivenRoutesUsingGET
 * url: getAllDemandDrivenRoutesUsingGETURL
 * method: getAllDemandDrivenRoutesUsingGET_TYPE
 * raw_url: getAllDemandDrivenRoutesUsingGET_RAW_URL
 * @param page - Page number of the requested page
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getAllDemandDrivenRoutesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ddroute'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllDemandDrivenRoutesUsingGET_RAW_URL = function() {
  return '/ddroute'
}
export const getAllDemandDrivenRoutesUsingGET_TYPE = function() {
  return 'get'
}
export const getAllDemandDrivenRoutesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ddroute'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addDemandDrivenRoute
 * request: addDemandDrivenRouteUsingPOST
 * url: addDemandDrivenRouteUsingPOSTURL
 * method: addDemandDrivenRouteUsingPOST_TYPE
 * raw_url: addDemandDrivenRouteUsingPOST_RAW_URL
 * @param ddRouteDto - ddRouteDTO
 */
export const addDemandDrivenRouteUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ddroute'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['ddRouteDto'] !== undefined) {
    body = parameters['ddRouteDto']
  }
  if (parameters['ddRouteDto'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: ddRouteDto'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addDemandDrivenRouteUsingPOST_RAW_URL = function() {
  return '/ddroute'
}
export const addDemandDrivenRouteUsingPOST_TYPE = function() {
  return 'post'
}
export const addDemandDrivenRouteUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ddroute'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * filterAllDemandDrivenRoutes
 * request: filterAllDemandDrivenRoutesUsingGET
 * url: filterAllDemandDrivenRoutesUsingGETURL
 * method: filterAllDemandDrivenRoutesUsingGET_TYPE
 * raw_url: filterAllDemandDrivenRoutesUsingGET_RAW_URL
 * @param demand - demand
 * @param end - end
 * @param notified - notified
 * @param page - Page number of the requested page
 * @param problem - problem
 * @param shortName - shortName
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @param start - start
 */
export const filterAllDemandDrivenRoutesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ddroute/filter'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['demand'] !== undefined) {
    queryParameters['demand'] = parameters['demand']
  }
  if (parameters['end'] !== undefined) {
    queryParameters['end'] = parameters['end']
  }
  if (parameters['notified'] !== undefined) {
    queryParameters['notified'] = parameters['notified']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['problem'] !== undefined) {
    queryParameters['problem'] = parameters['problem']
  }
  if (parameters['shortName'] !== undefined) {
    queryParameters['shortName'] = parameters['shortName']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['start'] !== undefined) {
    queryParameters['start'] = parameters['start']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const filterAllDemandDrivenRoutesUsingGET_RAW_URL = function() {
  return '/ddroute/filter'
}
export const filterAllDemandDrivenRoutesUsingGET_TYPE = function() {
  return 'get'
}
export const filterAllDemandDrivenRoutesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ddroute/filter'
  if (parameters['demand'] !== undefined) {
    queryParameters['demand'] = parameters['demand']
  }
  if (parameters['end'] !== undefined) {
    queryParameters['end'] = parameters['end']
  }
  if (parameters['notified'] !== undefined) {
    queryParameters['notified'] = parameters['notified']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['problem'] !== undefined) {
    queryParameters['problem'] = parameters['problem']
  }
  if (parameters['shortName'] !== undefined) {
    queryParameters['shortName'] = parameters['shortName']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters['start'] !== undefined) {
    queryParameters['start'] = parameters['start']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getDemandDrivenRoutes
 * request: getDemandDrivenRoutesUsingGET
 * url: getDemandDrivenRoutesUsingGETURL
 * method: getDemandDrivenRoutesUsingGET_TYPE
 * raw_url: getDemandDrivenRoutesUsingGET_RAW_URL
 * @param name - name
 */
export const getDemandDrivenRoutesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ddroute/list'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDemandDrivenRoutesUsingGET_RAW_URL = function() {
  return '/ddroute/list'
}
export const getDemandDrivenRoutesUsingGET_TYPE = function() {
  return 'get'
}
export const getDemandDrivenRoutesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ddroute/list'
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateDriverNotified
 * request: updateDriverNotifiedUsingPUT
 * url: updateDriverNotifiedUsingPUTURL
 * method: updateDriverNotifiedUsingPUT_TYPE
 * raw_url: updateDriverNotifiedUsingPUT_RAW_URL
 * @param id - id
 */
export const updateDriverNotifiedUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ddroute/notify/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateDriverNotifiedUsingPUT_RAW_URL = function() {
  return '/ddroute/notify/{id}'
}
export const updateDriverNotifiedUsingPUT_TYPE = function() {
  return 'put'
}
export const updateDriverNotifiedUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ddroute/notify/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getDemandDrivenRoutesShortNames
 * request: getDemandDrivenRoutesShortNamesUsingGET
 * url: getDemandDrivenRoutesShortNamesUsingGETURL
 * method: getDemandDrivenRoutesShortNamesUsingGET_TYPE
 * raw_url: getDemandDrivenRoutesShortNamesUsingGET_RAW_URL
 */
export const getDemandDrivenRoutesShortNamesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ddroute/short-name'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getDemandDrivenRoutesShortNamesUsingGET_RAW_URL = function() {
  return '/ddroute/short-name'
}
export const getDemandDrivenRoutesShortNamesUsingGET_TYPE = function() {
  return 'get'
}
export const getDemandDrivenRoutesShortNamesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ddroute/short-name'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getStopTimesOfRouteByDate
 * request: getStopTimesOfRouteByDateUsingGET
 * url: getStopTimesOfRouteByDateUsingGETURL
 * method: getStopTimesOfRouteByDateUsingGET_TYPE
 * raw_url: getStopTimesOfRouteByDateUsingGET_RAW_URL
 * @param date - date
 * @param directionId - direction_id
 * @param routeId - route_id
 * @param stopId - stop_id
 */
export const getStopTimesOfRouteByDateUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ddroute/times'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['date'] !== undefined) {
    queryParameters['date'] = parameters['date']
  }
  if (parameters['date'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: date'))
  }
  if (parameters['directionId'] !== undefined) {
    queryParameters['direction_id'] = parameters['directionId']
  }
  if (parameters['directionId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: directionId'))
  }
  if (parameters['routeId'] !== undefined) {
    queryParameters['route_id'] = parameters['routeId']
  }
  if (parameters['routeId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: routeId'))
  }
  if (parameters['stopId'] !== undefined) {
    queryParameters['stop_id'] = parameters['stopId']
  }
  if (parameters['stopId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stopId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStopTimesOfRouteByDateUsingGET_RAW_URL = function() {
  return '/ddroute/times'
}
export const getStopTimesOfRouteByDateUsingGET_TYPE = function() {
  return 'get'
}
export const getStopTimesOfRouteByDateUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ddroute/times'
  if (parameters['date'] !== undefined) {
    queryParameters['date'] = parameters['date']
  }
  if (parameters['directionId'] !== undefined) {
    queryParameters['direction_id'] = parameters['directionId']
  }
  if (parameters['routeId'] !== undefined) {
    queryParameters['route_id'] = parameters['routeId']
  }
  if (parameters['stopId'] !== undefined) {
    queryParameters['stop_id'] = parameters['stopId']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateTimetableModified
 * request: updateTimetableModifiedUsingPUT
 * url: updateTimetableModifiedUsingPUTURL
 * method: updateTimetableModifiedUsingPUT_TYPE
 * raw_url: updateTimetableModifiedUsingPUT_RAW_URL
 * @param id - id
 */
export const updateTimetableModifiedUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ddroute/timetable/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateTimetableModifiedUsingPUT_RAW_URL = function() {
  return '/ddroute/timetable/{id}'
}
export const updateTimetableModifiedUsingPUT_TYPE = function() {
  return 'put'
}
export const updateTimetableModifiedUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ddroute/timetable/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAllDemandDrivenRoutesByToday
 * request: getAllDemandDrivenRoutesByTodayUsingGET
 * url: getAllDemandDrivenRoutesByTodayUsingGETURL
 * method: getAllDemandDrivenRoutesByTodayUsingGET_TYPE
 * raw_url: getAllDemandDrivenRoutesByTodayUsingGET_RAW_URL
 * @param page - Page number of the requested page
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getAllDemandDrivenRoutesByTodayUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ddroute/today'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllDemandDrivenRoutesByTodayUsingGET_RAW_URL = function() {
  return '/ddroute/today'
}
export const getAllDemandDrivenRoutesByTodayUsingGET_TYPE = function() {
  return 'get'
}
export const getAllDemandDrivenRoutesByTodayUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ddroute/today'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAllTravellersOfRoute
 * request: getAllTravellersOfRouteUsingGET
 * url: getAllTravellersOfRouteUsingGETURL
 * method: getAllTravellersOfRouteUsingGET_TYPE
 * raw_url: getAllTravellersOfRouteUsingGET_RAW_URL
 * @param arrivalDate - arrivalDate
 * @param arrivalTime - arrivalTime
 * @param page - Page number of the requested page
 * @param routeId - routeId
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getAllTravellersOfRouteUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/ddroute/travellers'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['arrivalDate'] !== undefined) {
    queryParameters['arrivalDate'] = parameters['arrivalDate']
  }
  if (parameters['arrivalDate'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: arrivalDate'))
  }
  if (parameters['arrivalTime'] !== undefined) {
    queryParameters['arrivalTime'] = parameters['arrivalTime']
  }
  if (parameters['arrivalTime'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: arrivalTime'))
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['routeId'] !== undefined) {
    queryParameters['routeId'] = parameters['routeId']
  }
  if (parameters['routeId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: routeId'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllTravellersOfRouteUsingGET_RAW_URL = function() {
  return '/ddroute/travellers'
}
export const getAllTravellersOfRouteUsingGET_TYPE = function() {
  return 'get'
}
export const getAllTravellersOfRouteUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/ddroute/travellers'
  if (parameters['arrivalDate'] !== undefined) {
    queryParameters['arrivalDate'] = parameters['arrivalDate']
  }
  if (parameters['arrivalTime'] !== undefined) {
    queryParameters['arrivalTime'] = parameters['arrivalTime']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['routeId'] !== undefined) {
    queryParameters['routeId'] = parameters['routeId']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * parseGtfs
 * request: parseGtfsUsingGET
 * url: parseGtfsUsingGETURL
 * method: parseGtfsUsingGET_TYPE
 * raw_url: parseGtfsUsingGET_RAW_URL
 */
export const parseGtfsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gtfs/parse'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const parseGtfsUsingGET_RAW_URL = function() {
  return '/gtfs/parse'
}
export const parseGtfsUsingGET_TYPE = function() {
  return 'get'
}
export const parseGtfsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gtfs/parse'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getPercent
 * request: getPercentUsingGET
 * url: getPercentUsingGETURL
 * method: getPercentUsingGET_TYPE
 * raw_url: getPercentUsingGET_RAW_URL
 */
export const getPercentUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/gtfs/percent'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getPercentUsingGET_RAW_URL = function() {
  return '/gtfs/percent'
}
export const getPercentUsingGET_TYPE = function() {
  return 'get'
}
export const getPercentUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/gtfs/percent'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getRouteOfPassengers
 * request: getRouteOfPassengersUsingGET
 * url: getRouteOfPassengersUsingGETURL
 * method: getRouteOfPassengersUsingGET_TYPE
 * raw_url: getRouteOfPassengersUsingGET_RAW_URL
 * @param arrivalDate - arrivalDate
 * @param arrivalTime - arrivalTime
 * @param email - email
 * @param page - Page number of the requested page
 * @param routeId - routeId
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getRouteOfPassengersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/passenger'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['arrivalDate'] !== undefined) {
    queryParameters['arrivalDate'] = parameters['arrivalDate']
  }
  if (parameters['arrivalDate'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: arrivalDate'))
  }
  if (parameters['arrivalTime'] !== undefined) {
    queryParameters['arrivalTime'] = parameters['arrivalTime']
  }
  if (parameters['arrivalTime'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: arrivalTime'))
  }
  if (parameters['email'] !== undefined) {
    queryParameters['email'] = parameters['email']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['routeId'] !== undefined) {
    queryParameters['routeId'] = parameters['routeId']
  }
  if (parameters['routeId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: routeId'))
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRouteOfPassengersUsingGET_RAW_URL = function() {
  return '/passenger'
}
export const getRouteOfPassengersUsingGET_TYPE = function() {
  return 'get'
}
export const getRouteOfPassengersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/passenger'
  if (parameters['arrivalDate'] !== undefined) {
    queryParameters['arrivalDate'] = parameters['arrivalDate']
  }
  if (parameters['arrivalTime'] !== undefined) {
    queryParameters['arrivalTime'] = parameters['arrivalTime']
  }
  if (parameters['email'] !== undefined) {
    queryParameters['email'] = parameters['email']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['routeId'] !== undefined) {
    queryParameters['routeId'] = parameters['routeId']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * createPassenger
 * request: createPassengerUsingPOST
 * url: createPassengerUsingPOSTURL
 * method: createPassengerUsingPOST_TYPE
 * raw_url: createPassengerUsingPOST_RAW_URL
 * @param passengerVm - passengerVM
 */
export const createPassengerUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/passenger'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['passengerVm'] !== undefined) {
    body = parameters['passengerVm']
  }
  if (parameters['passengerVm'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: passengerVm'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createPassengerUsingPOST_RAW_URL = function() {
  return '/passenger'
}
export const createPassengerUsingPOST_TYPE = function() {
  return 'post'
}
export const createPassengerUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/passenger'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updatePassengerDemandRequest
 * request: updatePassengerDemandRequestUsingPUT
 * url: updatePassengerDemandRequestUsingPUTURL
 * method: updatePassengerDemandRequestUsingPUT_TYPE
 * raw_url: updatePassengerDemandRequestUsingPUT_RAW_URL
 * @param requestVm - requestVM
 */
export const updatePassengerDemandRequestUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/passenger'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['requestVm'] !== undefined) {
    body = parameters['requestVm']
  }
  if (parameters['requestVm'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: requestVm'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updatePassengerDemandRequestUsingPUT_RAW_URL = function() {
  return '/passenger'
}
export const updatePassengerDemandRequestUsingPUT_TYPE = function() {
  return 'put'
}
export const updatePassengerDemandRequestUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/passenger'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addPassengerDemandRequest
 * request: addPassengerDemandRequestUsingPOST
 * url: addPassengerDemandRequestUsingPOSTURL
 * method: addPassengerDemandRequestUsingPOST_TYPE
 * raw_url: addPassengerDemandRequestUsingPOST_RAW_URL
 * @param requestVm - requestVM
 */
export const addPassengerDemandRequestUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/passenger/request'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['requestVm'] !== undefined) {
    body = parameters['requestVm']
  }
  if (parameters['requestVm'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: requestVm'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addPassengerDemandRequestUsingPOST_RAW_URL = function() {
  return '/passenger/request'
}
export const addPassengerDemandRequestUsingPOST_TYPE = function() {
  return 'post'
}
export const addPassengerDemandRequestUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/passenger/request'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deletePassengerDemandRequest
 * request: deletePassengerDemandRequestUsingDELETE
 * url: deletePassengerDemandRequestUsingDELETEURL
 * method: deletePassengerDemandRequestUsingDELETE_TYPE
 * raw_url: deletePassengerDemandRequestUsingDELETE_RAW_URL
 * @param demandRequestId - demandRequestId
 */
export const deletePassengerDemandRequestUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/passenger/{demandRequestId}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{demandRequestId}', `${parameters['demandRequestId']}`)
  if (parameters['demandRequestId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: demandRequestId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deletePassengerDemandRequestUsingDELETE_RAW_URL = function() {
  return '/passenger/{demandRequestId}'
}
export const deletePassengerDemandRequestUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deletePassengerDemandRequestUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/passenger/{demandRequestId}'
  path = path.replace('{demandRequestId}', `${parameters['demandRequestId']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getUser
 * request: getUserUsingGET
 * url: getUserUsingGETURL
 * method: getUserUsingGET_TYPE
 * raw_url: getUserUsingGET_RAW_URL
 * @param email - email
 */
export const getUserUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/passenger/{email}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{email}', `${parameters['email']}`)
  if (parameters['email'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: email'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserUsingGET_RAW_URL = function() {
  return '/passenger/{email}'
}
export const getUserUsingGET_TYPE = function() {
  return 'get'
}
export const getUserUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/passenger/{email}'
  path = path.replace('{email}', `${parameters['email']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * registerAccount
 * request: registerAccountUsingPOST
 * url: registerAccountUsingPOSTURL
 * method: registerAccountUsingPOST_TYPE
 * raw_url: registerAccountUsingPOST_RAW_URL
 * @param managedUserVm - managedUserVM
 */
export const registerAccountUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/register'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['managedUserVm'] !== undefined) {
    body = parameters['managedUserVm']
  }
  if (parameters['managedUserVm'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: managedUserVm'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const registerAccountUsingPOST_RAW_URL = function() {
  return '/register'
}
export const registerAccountUsingPOST_TYPE = function() {
  return 'post'
}
export const registerAccountUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/register'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * addDemandRequest
 * request: addDemandRequestUsingPOST
 * url: addDemandRequestUsingPOSTURL
 * method: addDemandRequestUsingPOST_TYPE
 * raw_url: addDemandRequestUsingPOST_RAW_URL
 * @param demandRequestDto - demandRequestDTO
 */
export const addDemandRequestUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/request'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['demandRequestDto'] !== undefined) {
    body = parameters['demandRequestDto']
  }
  if (parameters['demandRequestDto'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: demandRequestDto'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const addDemandRequestUsingPOST_RAW_URL = function() {
  return '/request'
}
export const addDemandRequestUsingPOST_TYPE = function() {
  return 'post'
}
export const addDemandRequestUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/request'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * setRequestFavorite
 * request: setRequestFavoriteUsingPUT
 * url: setRequestFavoriteUsingPUTURL
 * method: setRequestFavoriteUsingPUT_TYPE
 * raw_url: setRequestFavoriteUsingPUT_RAW_URL
 * @param demandRequestFavoriteVm - demandRequestFavoriteVM
 */
export const setRequestFavoriteUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/request/favorite'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['demandRequestFavoriteVm'] !== undefined) {
    body = parameters['demandRequestFavoriteVm']
  }
  if (parameters['demandRequestFavoriteVm'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: demandRequestFavoriteVm'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const setRequestFavoriteUsingPUT_RAW_URL = function() {
  return '/request/favorite'
}
export const setRequestFavoriteUsingPUT_TYPE = function() {
  return 'put'
}
export const setRequestFavoriteUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/request/favorite'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getUserRequests
 * request: getUserRequestsUsingGET
 * url: getUserRequestsUsingGETURL
 * method: getUserRequestsUsingGET_TYPE
 * raw_url: getUserRequestsUsingGET_RAW_URL
 * @param page - Page number of the requested page
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getUserRequestsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/request/my'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserRequestsUsingGET_RAW_URL = function() {
  return '/request/my'
}
export const getUserRequestsUsingGET_TYPE = function() {
  return 'get'
}
export const getUserRequestsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/request/my'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteMyRequest
 * request: deleteMyRequestUsingDELETE
 * url: deleteMyRequestUsingDELETEURL
 * method: deleteMyRequestUsingDELETE_TYPE
 * raw_url: deleteMyRequestUsingDELETE_RAW_URL
 * @param requestId - request_id
 */
export const deleteMyRequestUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/request/my'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['requestId'] !== undefined) {
    queryParameters['request_id'] = parameters['requestId']
  }
  if (parameters['requestId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: requestId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteMyRequestUsingDELETE_RAW_URL = function() {
  return '/request/my'
}
export const deleteMyRequestUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteMyRequestUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/request/my'
  if (parameters['requestId'] !== undefined) {
    queryParameters['request_id'] = parameters['requestId']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getUserFavoriteRequests
 * request: getUserFavoriteRequestsUsingGET
 * url: getUserFavoriteRequestsUsingGETURL
 * method: getUserFavoriteRequestsUsingGET_TYPE
 * raw_url: getUserFavoriteRequestsUsingGET_RAW_URL
 * @param page - Page number of the requested page
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getUserFavoriteRequestsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/request/my/favorite'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserFavoriteRequestsUsingGET_RAW_URL = function() {
  return '/request/my/favorite'
}
export const getUserFavoriteRequestsUsingGET_TYPE = function() {
  return 'get'
}
export const getUserFavoriteRequestsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/request/my/favorite'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAllStops
 * request: getAllStopsUsingGET
 * url: getAllStopsUsingGETURL
 * method: getAllStopsUsingGET_TYPE
 * raw_url: getAllStopsUsingGET_RAW_URL
 */
export const getAllStopsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/stop/all'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllStopsUsingGET_RAW_URL = function() {
  return '/stop/all'
}
export const getAllStopsUsingGET_TYPE = function() {
  return 'get'
}
export const getAllStopsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/stop/all'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getFilteredStops
 * request: getFilteredStopsUsingGET
 * url: getFilteredStopsUsingGETURL
 * method: getFilteredStopsUsingGET_TYPE
 * raw_url: getFilteredStopsUsingGET_RAW_URL
 * @param latitude - latitude
 * @param longitude - longitude
 * @param name - name
 * @param page - Page number of the requested page
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getFilteredStopsUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/stop/filtered'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['latitude'] !== undefined) {
    queryParameters['latitude'] = parameters['latitude']
  }
  if (parameters['longitude'] !== undefined) {
    queryParameters['longitude'] = parameters['longitude']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getFilteredStopsUsingGET_RAW_URL = function() {
  return '/stop/filtered'
}
export const getFilteredStopsUsingGET_TYPE = function() {
  return 'get'
}
export const getFilteredStopsUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/stop/filtered'
  if (parameters['latitude'] !== undefined) {
    queryParameters['latitude'] = parameters['latitude']
  }
  if (parameters['longitude'] !== undefined) {
    queryParameters['longitude'] = parameters['longitude']
  }
  if (parameters['name'] !== undefined) {
    queryParameters['name'] = parameters['name']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * findNearestStop
 * request: findNearestStopUsingGET
 * url: findNearestStopUsingGETURL
 * method: findNearestStopUsingGET_TYPE
 * raw_url: findNearestStopUsingGET_RAW_URL
 * @param latitude - latitude
 * @param longitude - longitude
 */
export const findNearestStopUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/stop/nearest'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['latitude'] !== undefined) {
    queryParameters['latitude'] = parameters['latitude']
  }
  if (parameters['latitude'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: latitude'))
  }
  if (parameters['longitude'] !== undefined) {
    queryParameters['longitude'] = parameters['longitude']
  }
  if (parameters['longitude'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: longitude'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const findNearestStopUsingGET_RAW_URL = function() {
  return '/stop/nearest'
}
export const findNearestStopUsingGET_TYPE = function() {
  return 'get'
}
export const findNearestStopUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/stop/nearest'
  if (parameters['latitude'] !== undefined) {
    queryParameters['latitude'] = parameters['latitude']
  }
  if (parameters['longitude'] !== undefined) {
    queryParameters['longitude'] = parameters['longitude']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getStopsOfRoute
 * request: getStopsOfRouteUsingGET
 * url: getStopsOfRouteUsingGETURL
 * method: getStopsOfRouteUsingGET_TYPE
 * raw_url: getStopsOfRouteUsingGET_RAW_URL
 * @param directionId - direction_id
 * @param routeId - route_id
 */
export const getStopsOfRouteUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/stop/route'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['directionId'] !== undefined) {
    queryParameters['direction_id'] = parameters['directionId']
  }
  if (parameters['directionId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: directionId'))
  }
  if (parameters['routeId'] !== undefined) {
    queryParameters['route_id'] = parameters['routeId']
  }
  if (parameters['routeId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: routeId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getStopsOfRouteUsingGET_RAW_URL = function() {
  return '/stop/route'
}
export const getStopsOfRouteUsingGET_TYPE = function() {
  return 'get'
}
export const getStopsOfRouteUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/stop/route'
  if (parameters['directionId'] !== undefined) {
    queryParameters['direction_id'] = parameters['directionId']
  }
  if (parameters['routeId'] !== undefined) {
    queryParameters['route_id'] = parameters['routeId']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getRoutesOfStop
 * request: getRoutesOfStopUsingGET
 * url: getRoutesOfStopUsingGETURL
 * method: getRoutesOfStopUsingGET_TYPE
 * raw_url: getRoutesOfStopUsingGET_RAW_URL
 * @param stopId - stop_id
 */
export const getRoutesOfStopUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/stop/routes'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['stopId'] !== undefined) {
    queryParameters['stop_id'] = parameters['stopId']
  }
  if (parameters['stopId'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: stopId'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getRoutesOfStopUsingGET_RAW_URL = function() {
  return '/stop/routes'
}
export const getRoutesOfStopUsingGET_TYPE = function() {
  return 'get'
}
export const getRoutesOfStopUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/stop/routes'
  if (parameters['stopId'] !== undefined) {
    queryParameters['stop_id'] = parameters['stopId']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAllUsers
 * request: getAllUsersUsingGET
 * url: getAllUsersUsingGETURL
 * method: getAllUsersUsingGET_TYPE
 * raw_url: getAllUsersUsingGET_RAW_URL
 * @param page - Page number of the requested page
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getAllUsersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAllUsersUsingGET_RAW_URL = function() {
  return '/users'
}
export const getAllUsersUsingGET_TYPE = function() {
  return 'get'
}
export const getAllUsersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * createUser
 * request: createUserUsingPOST
 * url: createUserUsingPOSTURL
 * method: createUserUsingPOST_TYPE
 * raw_url: createUserUsingPOST_RAW_URL
 * @param userDto - userDTO
 */
export const createUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['userDto'] !== undefined) {
    body = parameters['userDto']
  }
  if (parameters['userDto'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userDto'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createUserUsingPOST_RAW_URL = function() {
  return '/users'
}
export const createUserUsingPOST_TYPE = function() {
  return 'post'
}
export const createUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * updateUser
 * request: updateUserUsingPUT
 * url: updateUserUsingPUTURL
 * method: updateUserUsingPUT_TYPE
 * raw_url: updateUserUsingPUT_RAW_URL
 * @param userDto - userDTO
 */
export const updateUserUsingPUT = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['userDto'] !== undefined) {
    body = parameters['userDto']
  }
  if (parameters['userDto'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: userDto'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const updateUserUsingPUT_RAW_URL = function() {
  return '/users'
}
export const updateUserUsingPUT_TYPE = function() {
  return 'put'
}
export const updateUserUsingPUTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getAuthorities
 * request: getAuthoritiesUsingGET
 * url: getAuthoritiesUsingGETURL
 * method: getAuthoritiesUsingGET_TYPE
 * raw_url: getAuthoritiesUsingGET_RAW_URL
 */
export const getAuthoritiesUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/authorities'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getAuthoritiesUsingGET_RAW_URL = function() {
  return '/users/authorities'
}
export const getAuthoritiesUsingGET_TYPE = function() {
  return 'get'
}
export const getAuthoritiesUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/authorities'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * banUser
 * request: banUserUsingDELETE
 * url: banUserUsingDELETEURL
 * method: banUserUsingDELETE_TYPE
 * raw_url: banUserUsingDELETE_RAW_URL
 * @param email - email
 * @param isBanned - isBanned
 */
export const banUserUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/ban/{email}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{email}', `${parameters['email']}`)
  if (parameters['email'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: email'))
  }
  if (parameters['isBanned'] !== undefined) {
    queryParameters['isBanned'] = parameters['isBanned']
  }
  if (parameters['isBanned'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: isBanned'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const banUserUsingDELETE_RAW_URL = function() {
  return '/users/ban/{email}'
}
export const banUserUsingDELETE_TYPE = function() {
  return 'delete'
}
export const banUserUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/ban/{email}'
  path = path.replace('{email}', `${parameters['email']}`)
  if (parameters['isBanned'] !== undefined) {
    queryParameters['isBanned'] = parameters['isBanned']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getManagementUsers
 * request: getManagementUsersUsingGET
 * url: getManagementUsersUsingGETURL
 * method: getManagementUsersUsingGET_TYPE
 * raw_url: getManagementUsersUsingGET_RAW_URL
 * @param page - Page number of the requested page
 * @param search - search
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getManagementUsersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/management'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['search'] !== undefined) {
    queryParameters['search'] = parameters['search']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getManagementUsersUsingGET_RAW_URL = function() {
  return '/users/management'
}
export const getManagementUsersUsingGET_TYPE = function() {
  return 'get'
}
export const getManagementUsersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/management'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['search'] !== undefined) {
    queryParameters['search'] = parameters['search']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * createManagedUser
 * request: createManagedUserUsingPOST
 * url: createManagedUserUsingPOSTURL
 * method: createManagedUserUsingPOST_TYPE
 * raw_url: createManagedUserUsingPOST_RAW_URL
 * @param managedUserVm - managedUserVM
 */
export const createManagedUserUsingPOST = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/management'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['managedUserVm'] !== undefined) {
    body = parameters['managedUserVm']
  }
  if (parameters['managedUserVm'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: managedUserVm'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const createManagedUserUsingPOST_RAW_URL = function() {
  return '/users/management'
}
export const createManagedUserUsingPOST_TYPE = function() {
  return 'post'
}
export const createManagedUserUsingPOSTURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/management'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getTravellers
 * request: getTravellersUsingGET
 * url: getTravellersUsingGETURL
 * method: getTravellersUsingGET_TYPE
 * raw_url: getTravellersUsingGET_RAW_URL
 * @param page - Page number of the requested page
 * @param search - search
 * @param size - Size of a page
 * @param sort - Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
export const getTravellersUsingGET = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/travellers'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['search'] !== undefined) {
    queryParameters['search'] = parameters['search']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getTravellersUsingGET_RAW_URL = function() {
  return '/users/travellers'
}
export const getTravellersUsingGET_TYPE = function() {
  return 'get'
}
export const getTravellersUsingGETURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/travellers'
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['search'] !== undefined) {
    queryParameters['search'] = parameters['search']
  }
  if (parameters['size'] !== undefined) {
    queryParameters['size'] = parameters['size']
  }
  if (parameters['sort'] !== undefined) {
    queryParameters['sort'] = parameters['sort']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * getUser
 * request: getUserUsingGET_1
 * url: getUserUsingGET_1URL
 * method: getUserUsingGET_1_TYPE
 * raw_url: getUserUsingGET_1_RAW_URL
 * @param email - email
 */
export const getUserUsingGET_1 = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/{email}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{email}', `${parameters['email']}`)
  if (parameters['email'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: email'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const getUserUsingGET_1_RAW_URL = function() {
  return '/users/{email}'
}
export const getUserUsingGET_1_TYPE = function() {
  return 'get'
}
export const getUserUsingGET_1URL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/{email}'
  path = path.replace('{email}', `${parameters['email']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * deleteUser
 * request: deleteUserUsingDELETE
 * url: deleteUserUsingDELETEURL
 * method: deleteUserUsingDELETE_TYPE
 * raw_url: deleteUserUsingDELETE_RAW_URL
 * @param email - email
 */
export const deleteUserUsingDELETE = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/users/{email}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{email}', `${parameters['email']}`)
  if (parameters['email'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: email'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const deleteUserUsingDELETE_RAW_URL = function() {
  return '/users/{email}'
}
export const deleteUserUsingDELETE_TYPE = function() {
  return 'delete'
}
export const deleteUserUsingDELETEURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/users/{email}'
  path = path.replace('{email}', `${parameters['email']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}